// Demo worker data
const demoWorkers = [
  {
    name: "Ramesh Kumar",
    mobile: "9905306080",
    type: "Labour",
    state: "Maharashtra",
    district: "Mumbai",
    city: "Mumbai",
    experience: 5,
    rating: 4.5,
    specialization: "Electrical work",
    photo: "https://randomuser.me/api/portraits/men/1.jpg",
  },
  {
    name: "Suresh Patel",
    mobile: "9123456780",
    type: "Mason",
    state: "Maharashtra",
    district: "Pune",
    city: "Pune",
    experience: 3,
    rating: 4,
    specialization: "Masonry",
    photo: null,
  },
  {
    name: "Priya Sharma",
    mobile: "9988776655",
    type: "Plumber",
    state: "Karnataka",
    district: "Bangalore Urban",
    city: "Bangalore",
    experience: 4,
    rating: 4.8,
    specialization: "Pipe fitting",
    photo: "https://randomuser.me/api/portraits/women/2.jpg",
  },
];

export default demoWorkers;
